import { Box, Checkbox, Typography } from '@mui/material';
import AutocolonList from 'app/components/AutocolonList';
import { divisionAutocolnSortedItemsTransportSelector } from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { getUserAutocolons, userAutocolonDelete, userAutocolonPush, userAutocolonsDelete, userAutocolonsListDelete, userAutocolonsPush, } from 'app/store/user';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
const UserAutocolonList = () => {
    const { selectedItem } = useSelector((state) => state.user);
    const autocolonCheckedItems = selectedItem.autocolons || [];
    const { asyncAction: getAutocolons, isLoading: isGetAutocolons } = useAsyncAction(getUserAutocolons, [selectedItem.id]);
    useEffect(() => {
        getAutocolons(selectedItem.id);
    }, [selectedItem.id]);
    const { asyncAction: addGroup, isLoading: isAddGroup } = useAsyncAction(userAutocolonsPush, [selectedItem.id]);
    const { asyncAction: deleteGroup, isLoading: isDeleteGroup } = useAsyncAction(userAutocolonsListDelete, [selectedItem.id]);
    const { asyncAction: pushSubmit, isLoading: isPushSubmit } = useAsyncAction(userAutocolonPush, [selectedItem.id]);
    const { asyncAction: deleteSubmit, isLoading: isDeleteSubmit } = useAsyncAction(userAutocolonDelete, [selectedItem.id]);
    const { asyncAction: deleteAll, isLoading: isDeleteAll } = useAsyncAction(userAutocolonsDelete, [selectedItem.id]);
    const divisions = useSelector(divisionAutocolnSortedItemsTransportSelector);
    const items = divisions.reduce((acc, division) => {
        const autocolons = division.autocolons.map((autocolon) => {
            return Object.assign(Object.assign({}, autocolon), { checked: autocolonCheckedItems.includes(autocolon.id) });
        });
        const divisionChecked = autocolons.filter((item) => !item.checked).length === 0;
        acc.push(Object.assign(Object.assign({}, division), { autocolons, checked: divisionChecked }));
        return acc;
    }, []);
    const isCheckedAll = items.filter((division) => !division.checked).length === 0;
    const handleItemClick = (value) => {
        value.checked ? deleteSubmit(selectedItem.id, value.id) : pushSubmit(selectedItem.id, value.id);
    };
    const handleCheckAll = () => {
        if (isAddGroup || isDeleteGroup)
            return;
        if (isCheckedAll) {
            deleteAll(selectedItem.id);
        }
        else {
            const list = items.reduce((acc, { autocolons }) => {
                const unchecked = autocolons.filter((item) => !item.checked).map((item) => item.id);
                acc = acc.concat(unchecked);
                return acc;
            }, []);
            addGroup(selectedItem.id, list);
        }
    };
    const handleCheckAllDivision = (e, { autocolons, checked }) => {
        e.stopPropagation();
        e.preventDefault();
        if (isAddGroup || isDeleteGroup)
            return;
        if (checked) {
            deleteGroup(selectedItem.id, autocolons.map((item) => item.id));
        }
        else {
            addGroup(selectedItem.id, autocolons.filter((item) => !item.checked).map((item) => item.id));
        }
    };
    const startExpanded = items.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
    }, {});
    const [expanded, setExtended] = useState(startExpanded);
    const handleAccordionChange = (key) => {
        setExtended(Object.assign(Object.assign({}, expanded), { [key]: !expanded[key] }));
    };
    const isCheckboxDisabled = isDeleteSubmit || isPushSubmit || isAddGroup || isDeleteGroup || isDeleteAll || isGetAutocolons;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                textAlign: 'end',
                paddingRight: '24px',
                cursor: 'pointer',
                font: 'inherit',
            }, onClick: handleCheckAll },
            React.createElement(Typography, { component: 'span' }, "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0451"),
            React.createElement(Checkbox, { size: 'small', edge: 'end', disableRipple: true, checked: isCheckedAll, disabled: isCheckboxDisabled })),
        React.createElement(AutocolonList, { isCheckboxDisabled: isCheckboxDisabled, items: items, expanded: expanded, handleAccordionChange: handleAccordionChange, handleItemClick: handleItemClick, handleCheckAllDivision: handleCheckAllDivision })));
};
export default UserAutocolonList;
